import { create } from 'zustand';

interface DeathState {
  isDead: boolean;
  respawnAt: number; // epoch ms when respawn happens
  message: string;
  show: (durationMs: number, message?: string) => void;
  hide: () => void;
}

export const useDeathStore = create<DeathState>((set) => ({
  isDead: false,
  respawnAt: 0,
  message: 'Bạn đã chết',
  show: (durationMs, message = 'Bạn đã chết') =>
    set({ isDead: true, respawnAt: Date.now() + durationMs, message }),
  hide: () => set({ isDead: false, respawnAt: 0 }),
}));
